/**
 * Opções de upload e análise de transcrição
 */

/**
 * Tipos de análise disponíveis
 */
export type AnalysisType = 
  | 'sentiment'   // Análise de sentimento
  | 'entities'    // Extração de entidades
  | 'topics'      // Detecção de tópicos
  | 'patterns'    // Padrões de comunicação
  | 'summary'     // Resumo com IA
  | 'timeline'    // Timeline de eventos

/**
 * Informações sobre cada tipo de análise
 */
export interface AnalysisTypeInfo {
  id: AnalysisType
  label: string
  description: string
  icon: string
  estimatedTime: string
}

/**
 * Opções de upload configuradas pelo usuário
 */
export interface UploadOptions {
  /**
   * Se true, habilita análise da transcrição.
   * Se false, apenas transcreve sem análise.
   */
  enableAnalysis: boolean
  
  /**
   * Lista de análises selecionadas (quando enableAnalysis = true)
   */
  selectedAnalyses: AnalysisType[]
  
  /**
   * Se true, envia email de notificação ao concluir
   */
  notifyByEmail: boolean
  
  /**
   * Email para notificação (opcional, usa email do usuário por padrão)
   */
  notificationEmail?: string
}

/**
 * Configurações default de upload
 */
export const DEFAULT_UPLOAD_OPTIONS: UploadOptions = {
  enableAnalysis: true,
  selectedAnalyses: ['sentiment', 'entities', 'topics', 'patterns', 'summary', 'timeline'],
  notifyByEmail: false,
  notificationEmail: undefined
}

/**
 * Informações detalhadas sobre cada tipo de análise
 */
export const ANALYSIS_TYPES: AnalysisTypeInfo[] = [
  {
    id: 'sentiment',
    label: 'Análise de Sentimento',
    description: 'Detecta emoções e tom do diálogo em cada trecho. Identifica se o discurso é positivo, neutro ou negativo.',
    icon: 'SentimentSatisfied',
    estimatedTime: '~30s'
  },
  {
    id: 'entities',
    label: 'Extração de Entidades',
    description: 'Identifica automaticamente pessoas, locais, organizações, datas, valores monetários e termos jurídicos mencionados.',
    icon: 'Label',
    estimatedTime: '~45s'
  },
  {
    id: 'topics',
    label: 'Detecção de Tópicos',
    description: 'Categoriza os principais assuntos abordados na conversa e indica a relevância de cada tema.',
    icon: 'Topic',
    estimatedTime: '~30s'
  },
  {
    id: 'patterns',
    label: 'Padrões de Comunicação',
    description: 'Analisa estilos de fala, interrupções, tempo de resposta e características individuais de cada participante.',
    icon: 'RecordVoiceOver',
    estimatedTime: '~40s'
  },
  {
    id: 'summary',
    label: 'Resumo com IA',
    description: 'Gera um resumo inteligente do conteúdo, destacando os pontos principais e conclusões da conversa.',
    icon: 'Summarize',
    estimatedTime: '~60s'
  },
  {
    id: 'timeline',
    label: 'Timeline de Eventos',
    description: 'Organiza cronologicamente os eventos, decisões e compromissos mencionados durante a transcrição.',
    icon: 'Timeline',
    estimatedTime: '~35s'
  }
]
